<template>
  <div class="position-relative">
    <AlertBlock
      v-if="!training.titleRncp"
      :text="$t('training.rncp.alert.empty_rncp_warning_text')"
      type="warning"
      icon="warning"
    />
    <TrainingRncpWorkflowComponent
      :training="training"
      :importing="importing"
      :enriching="enriching"
      :publishing="publishing"
      @import="importTitle"
      @enrich="enrich"
      @publish="publish"
    />
    <template v-if="training.titleRncp">
      <TrainingRncpSheetComponent
        :active="active"
        :hasBeenImportedOnce="hasBeenImportedOnce"
        :importing="importing"
        ref="trainingRncpSheetComponent"
      />
      <TrainingSkillComponent
        :active="active"
        :hasBeenImportedOnce="hasBeenImportedOnce"
        :hasBeenEnrichedOnce="hasBeenEnrichedOnce"
        :importing="importing"
        :enriching="enriching"
        ref="trainingSkillComponent"
        @refresh="refresh"
        @error="error"
      />
    </template>
  </div>
  <TrainingRncpImportModalComponent :open="modalOpen" @import="importTitle" @hidden="modalHidden" />
</template>

<script>
import TrainingRncpWorkflowComponent from "@/components/training/rncp/TrainingRncpWorkflowComponent.vue";
import TrainingRncpSheetComponent from "@/components/training/rncp/TrainingRncpSheetComponent.vue";
import { trainingManager } from "@/services/training/training-manager";
import TrainingSkillComponent from "@/components/training/skill/TrainingSkillComponent.vue";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import AlertBlock from "@/components/blocks/AlertBlock.vue";
import TrainingRncpImportModalComponent from "@/components/training/rncp/TrainingRncpImportModalComponent.vue";

export default {
  name: "TrainingRncpComponent",
  emits: ["refresh"],
  components: {
    TrainingRncpImportModalComponent,
    AlertBlock,
    TrainingSkillComponent,
    TrainingRncpSheetComponent,
    TrainingRncpWorkflowComponent,
  },
  props: {
    training: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasBeenImportedOnce() {
      return !!this.training.lastSkillImportDate;
    },
    hasBeenEnrichedOnce() {
      return !!this.training.lastIAEnrichDate;
    },
  },
  data() {
    return {
      importing: false,
      enriching: false,
      publishing: false,
      modalOpen: false,
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.importing = this.isImporting();
      this.enriching = this.isEnriching();
    },

    isImporting() {
      return !!sessionStorage.getItem("studea-training-" + this.$route.params.trainingId + "-rncpImportMessageId");
    },

    isEnriching() {
      return !!sessionStorage.getItem("studea-training-" + this.$route.params.trainingId + "-rncpEnrichingMessageId");
    },

    importTitle(type = null) {
      if (this.hasBeenImportedOnce && !type) {
        this.modalOpen = true;
      } else {
        type = !type ? "crush" : type;
        this.startImport(type);
      }
    },

    async startImport(type = null) {
      if (type === "crush") {
        this.clearData();
      }
      const response = await trainingManager.get(
        this.$route.params.trainingId,
        "france-competence/import/skill?action=" + type,
      );
      sessionStorage.setItem(
        "studea-training-" + this.$route.params.trainingId + "-rncpImportMessageId",
        response.messageId,
      );
      this.importing = true;
      messengerMessageManager.processMessage(response);
    },

    async enrich() {
      this.enriching = true;
      const response = await trainingManager.post(this.$route.params.trainingId, "skill/enrich-skills-missions");
      if (response) {
        sessionStorage.setItem(
          "studea-training-" + this.$route.params.trainingId + "-rncpEnrichingMessageId",
          response.messageId,
        );
        messengerMessageManager.processMessage(response);
      }
    },

    clearData() {
      if (this.$refs.trainingSkillComponent) {
        this.$refs.trainingSkillComponent.clearData();
      }
      if (this.$refs.trainingRncpSheetComponent) {
        this.$refs.trainingRncpSheetComponent.clearData();
      }
    },

    async publish(params) {
      this.publishing = true;
      const response = await trainingManager.post(this.$route.params.trainingId, "skill/publish-skills", params);
      if (response && response.success) {
        this.refresh();
        notificationManager.showNotification("success", i18n.global.t("training.publish_success"));
      } else {
        this.error();
      }
    },

    refresh() {
      this.importing = false;
      this.enriching = false;
      this.publishing = false;
      sessionStorage.removeItem("studea-training-" + this.$route.params.trainingId + "-rncpImportMessageId");
      sessionStorage.removeItem("studea-training-" + this.$route.params.trainingId + "-rncpEnrichingMessageId");
      this.$emit("refresh");
    },

    error() {
      this.importing = false;
      this.enriching = false;
      this.publishing = false;
      sessionStorage.removeItem("studea-training-" + this.$route.params.trainingId + "-rncpImportMessageId");
      sessionStorage.removeItem("studea-training-" + this.$route.params.trainingId + "-rncpEnrichingMessageId");
      notificationManager.showNotification("error", i18n.global.t("training.rncp.alert.error"));
    },

    modalHidden() {
      this.modalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
